<template>
  <div class="">
    <agency-sectors-edit> </agency-sectors-edit>
  </div>
</template>

<script>
import AgencySectorsEdit from "@/components/profile/sectors/agency/edit.vue";
import { mapActions, mapGetters } from "vuex";

export default {
  methods: {
    ...mapActions("queue", ["notifyQueue"]),
    ...mapActions("breadcrumbs", { removeBCS: "remove" }),
    ...mapGetters("breadcrumbs", { loadBCS: "loadBreadcrumbs" }),
  },
  components: {
    AgencySectorsEdit,
  },
  beforeMount() {
    let bcs = this.loadBCS();
    if (this.$route.query.fromShortcut) {
      bcs.push({
        text: "Comparti di agenzia",
        path: "module.PROF.COMP",
        tab: "AgencySectors",
        level: 3,
      });
      bcs.push({
        text: "Modifica Comparto di agenzia",
        path: "sectors.edit0",
        level: 3,
      });
      bcs.forEach((element) => {
        this.notifyQueue({
          text: element.text,
          path: element.path,
          tab: element.tab,
          level: element.level,
          disabled: element.disabled,
        });
      });
      // this.$router.replace({ query: null });
    } else {
      this.notifyQueue({
        text: "Comparti di agenzia",
        path: "module.PROF.COMP",
        tab: "AgencySectors",
        level: 3,
      });
      this.notifyQueue({
        text: "Modifica Comparto di agenzia",
        path: "sectors.edit0",
        level: 4,
      });
    }
  },
};
</script>
